module.exports = __webpack_public_path__ + "static/media/icon_edit_selected.8e2f292a.svg";